import {ChangeDetectionStrategy, Component, OnInit, inject} from '@angular/core';
import {Router, RouterLink} from '@angular/router';
import {hasStoredToken} from '../../core/services/session-token';

/**
 * Shown for any URL the app doesn't know. nginx serves the prerendered copy with a 404 status;
 * in the browser the router lands here through the '**' route.
 */
@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  imports: [RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotFoundComponent implements OnInit {

  private readonly router = inject(Router);

  /** The path that wasn't found; empty for /404 itself, which is only ever reached on purpose. */
  missingPath = '';
  userIsLoggedIn = false;

  ngOnInit() {
    const path = this.router.url.split(/[?#]/)[0];
    this.missingPath = path === '/404' ? '' : path;
    this.userIsLoggedIn = hasStoredToken();
  }
}
